import { render, staticRenderFns } from "./about-slider-standard-item.vue?vue&type=template&id=1d8f0bf7&scoped=true&"
import script from "./about-slider-standard-item.vue?vue&type=script&lang=js&"
export * from "./about-slider-standard-item.vue?vue&type=script&lang=js&"
import style0 from "./about-slider-standard-item.vue?vue&type=style&index=0&id=1d8f0bf7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8f0bf7",
  null
  
)

export default component.exports